import { BillDetailed } from '@enview/interface/types/bills/Bill';
import { OrganizationUser } from '@enview/interface/types/OrganizationUser';
import { Person } from '@enview/interface/types/Person';
import { track } from './SegmentAnalytics';

enum AnalyticsEvent {
  FILTER_ACTIVITY_FEED = 'Filter Activity Feed',
}

const FEDERAL = 'federal';

const TEAM = 'Team feed';
const BILL = 'Bill feed';
const PERSON = 'Person feed';

export const trackFilterActivityFeed = (
  values: string[],
  teamId: number,
  orgUser?: OrganizationUser,
  bill?: BillDetailed,
  person?: Person,
): void => {
  let where;
  if (bill) {
    where = BILL;
  } else if (person) {
    where = PERSON;
  } else {
    where = TEAM;
  }
  track(AnalyticsEvent.FILTER_ACTIVITY_FEED, {
    billId: bill ? bill.id : null,
    state: bill ? bill.state : null,
    jurisdiction: bill ? bill.state || FEDERAL : null,
    username: orgUser ? orgUser.email : 'Not logged in',
    teamId,
    values: values.join(', '),
    where,
  });
};
